import { LogoutModal } from './LogoutModal.main';

export { LogoutModal };
